const prepaidCardStatus = {
  UNLOCK: 1,
  LOCK: 2
}
export default prepaidCardStatus
